/*! one-spot — Mediashop PDP behaviors. Loaded by Mediashop product templates. */
(function () {
  "use strict";

  // Below-fold sections are stamped x-ignore by the theme and only Alpine-hydrated
  // when they enter the viewport. We pulse on an interval as a safety net while
  // also observing intersection — first signal wins.
  const FAQ_PULSE_INTERVAL_MS = 150;
  const FAQ_PULSE_MAX_ATTEMPTS = 150;
  const FAQ_INTERSECT_ROOT_MARGIN = "400px";

  // Re-run injections after these delays — covers theme JS reflowing the gallery
  // (swiper init, variant-change re-render). Idempotent via dataset markers.
  const INIT_RETRY_DELAYS_MS = [800, 2000];

  const ANCHOR_FAQ_RECHECK_DELAY_MS = 300;
  const CAPTION_INITIAL_DELAY_MS = 200;
  const MODAL_FOCUS_DELAY_MS = 50;
  const CAPTION_MIN_ALT_LENGTH = 3;

  // Order must match the trust-strip column block_order in the PDP template.
  const TRUST_KEY_BY_INDEX = ["original", "garantie", "versand", "rechnung"];

  // Used only if sections/pdp-trust-modals.liquid is missing from the template.
  const TRUST_CONTENT_FALLBACK = {
    original: {
      title: "Das ORIGINAL aus dem TV!",
      body: "<p>Sie kennen unsere Produkte aus Werbespots im TV. Bei mediashop.tv erhalten Sie ausschließlich die Original-Markenartikel von Mediashop – keine Imitate.</p>",
    },
    garantie: {
      title: "Geld-zurück-Garantie",
      body: "<p>Sie haben bei uns ein 30-tägiges Rückgaberecht. Sind Sie mit Ihrer Bestellung nicht zufrieden, erstatten wir Ihnen den Kaufpreis.</p>",
    },
    versand: {
      title: "Gratis Versand ab 49,-",
      body: "<p>Bei einem Bestellwert ab 49,- Euro liefern wir Ihre Bestellung kostenlos. Bei kleineren Bestellungen fällt eine geringe Versandpauschale an.</p>",
    },
    rechnung: {
      title: "Kauf auf Rechnung",
      body: "<p>Bezahlen Sie bequem nach Erhalt der Ware per Rechnung. Sie haben 14 Tage Zeit, den Rechnungsbetrag zu begleichen.</p>",
    },
  };

  function warn(scope, err) {
    if (typeof console !== "undefined" && console.warn) {
      console.warn("[pdp-mediashop:" + scope + "]", err);
    }
  }

  function tryOpenFirstFaq() {
    const section = document.querySelector('[id$="__accordion"]');
    if (!section) return false;

    // Force-init Alpine if the theme's lazy IntersectionObserver hasn't fired yet.
    if (window.Alpine && typeof window.Alpine.initTree === "function") {
      if (section.hasAttribute("x-ignore")) {
        section.removeAttribute("x-ignore");
        try {
          window.Alpine.initTree(section);
        } catch (e) {
          warn("faq.initTree", e);
        }
      }
      section.querySelectorAll("[x-ignore]").forEach(function (el) {
        el.removeAttribute("x-ignore");
        try {
          window.Alpine.initTree(el);
        } catch (e) {
          warn("faq.initTree.child", e);
        }
      });
    }

    const first = section.querySelector(".faq-item");
    if (!first) return false;
    if (first.dataset.msOpened === "1") return true;

    if (first._x_dataStack && window.Alpine && typeof window.Alpine.$data === "function") {
      try {
        const d = window.Alpine.$data(first);
        if (d && "open" in d) {
          d.open = true;
          first.dataset.msOpened = "1";
          return true;
        }
      } catch (e) {
        warn("faq.openFirst", e);
      }
    }

    const btn = first.querySelector("button[aria-label], .faq-collapsible");
    if (btn && first._x_dataStack) {
      btn.click();
      first.dataset.msOpened = "1";
      return true;
    }
    return false;
  }

  let faqAttempt = 0;
  let faqTimer;
  let accordionObserver;
  let variantBadgeObserver;
  let variantBadgeController;
  let variantBadgeHost;
  let retryTimers = [];
  function pulseFaq() {
    clearTimeout(faqTimer);
    if (tryOpenFirstFaq()) {
      accordionObserver?.disconnect();
      return;
    }
    if (faqAttempt++ < FAQ_PULSE_MAX_ATTEMPTS) faqTimer = setTimeout(pulseFaq, FAQ_PULSE_INTERVAL_MS);
  }

  function watchAccordion() {
    accordionObserver?.disconnect();
    clearTimeout(faqTimer);
    faqAttempt = 0;
    const s = document.querySelector('[id$="__accordion"]');
    if (s && "IntersectionObserver" in window) {
      accordionObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              faqAttempt = 0;
              pulseFaq();
            }
          });
        },
        { rootMargin: FAQ_INTERSECT_ROOT_MARGIN },
      );
      accordionObserver.observe(s);
    }
    pulseFaq();
  }

  function openFaqItem(item) {
    if (!item) return;
    setTimeout(function () {
      try {
        const setOpen = function () {
          if (!item._x_dataStack || !window.Alpine || !window.Alpine.$data) return;
          const data = window.Alpine.$data(item);
          if (data && "open" in data) data.open = true;
        };

        if (!item._x_dataStack && window.Alpine && typeof window.Alpine.initTree === "function") {
          window.Alpine.initTree(item);
          setTimeout(setOpen, 50);
          return;
        }
        setOpen();
      } catch (err) {
        warn("anchorNav.openFaq", err);
      }
    }, ANCHOR_FAQ_RECHECK_DELAY_MS);
  }

  function populateAnchorNav() {
    const nav = document.querySelector(".ms-anchor-nav__inner[data-ms-anchor-nav]");
    if (!nav || nav.dataset.msPopulated) return;
    const section = document.querySelector('[id$="__accordion"]');
    if (!section) return;
    const items = section.querySelectorAll(".faq-item");
    if (!items.length) return;

    items.forEach(function (item) {
      // Defensive: skip tabs that have been hidden (e.g. empty Bewertungen /
      // Downloads via hideEmptyAccordionTabs). Without this, the anchor nav
      // would render links to tabs the user can't see.
      if (item.style.display === "none") return;
      const heading = item.querySelector(".faq-collapsible");
      if (!heading) return;
      const label = (heading.textContent || "").trim();
      if (!label) return;
      const a = document.createElement("a");
      a.href = "#";
      a.textContent = label;
      a.addEventListener("click", function (e) {
        e.preventDefault();
        item.scrollIntoView({ behavior: "smooth", block: "start" });
        openFaqItem(item);
      });
      nav.appendChild(a);
    });
    nav.dataset.msPopulated = "1";
  }

  function wireMehrDetailsScroll() {
    document.querySelectorAll('a[data-ms-target="pdp-details"]').forEach(function (link) {
      const target = document.getElementById("ms-pdp-details");
      if (!target || !target.children.length) {
        const wrap = link.closest("p") || link;
        wrap.hidden = true;
        return;
      }
      if (link.dataset.msPdpDetailsWired) return;
      link.dataset.msPdpDetailsWired = "1";
      link.addEventListener("click", function (e) {
        e.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function relabelSku() {
    document.querySelectorAll(".block-identifier__sku, .product-info__sku").forEach(function (el) {
      if (el.dataset.msRelabeled) return;
      el.innerHTML = el.innerHTML
        .replace(/Artikelnummer\s*\(SKU\)\s*:/i, "Art.Nr.:")
        .replace(/^\s*SKU\s*:/i, "Art.Nr.:");
      el.dataset.msRelabeled = "1";
    });
  }

  // Anchored to .media-gallery__media-wrapper (sibling of thumbs); the inner
  // slider container uses overflow:hidden which would clip the badges.
  function injectProductBadges() {
    const cfg = window.MS_PDP;
    if (!cfg) return;
    const badges = [
      { active: cfg.isNew, className: "ms-neu-badge", label: "NEU" },
      { active: cfg.isBWare, className: "ms-bware-badge", label: "B-Ware" },
      { active: cfg.isBestseller, className: "ms-bestseller-badge", label: "BESTSELLER" },
    ].filter(function (badge) {
      return badge.active;
    });
    if (!badges.length) return;

    const host = document.querySelector(".product-template__media-wrapper .media-gallery__media-wrapper");
    if (!host || host.dataset.msProductBadges) return;
    host.style.position = "relative";

    const stack = document.createElement("div");
    stack.className = "ms-product-badges";
    badges.forEach(function (item) {
      const badge = document.createElement("div");
      badge.className = "ms-product-badge " + item.className;
      badge.textContent = item.label;
      stack.appendChild(badge);
    });
    host.appendChild(stack);
    host.dataset.msProductBadges = "1";
  }

  // Top-right "UVP -X%" badge — shown only when compare_at_price > price.
  // Prices are exposed in cents on window.MS_PDP. Round to whole percent.
  function injectUvpBadge() {
    const cfg = window.MS_PDP;
    if (!cfg) return;
    const price = Number(cfg.price);
    const compare = Number(cfg.compareAtPrice);
    if (!compare || !price || compare <= price) return;
    const pct = Math.round(((compare - price) / compare) * 100);
    if (pct <= 0) return;

    const host = document.querySelector(".product-template__media-wrapper .media-gallery__media-wrapper");
    if (!host || host.dataset.msUvp) return;
    host.style.position = "relative";
    const badge = document.createElement("div");
    badge.className = "ms-uvp-badge";
    badge.textContent = "UVP -" + pct + "%";
    host.appendChild(badge);
    host.dataset.msUvp = "1";
  }

  // Top-right badge showing active variant's option1 (e.g. "24cm").
  // Only renders when the product has multiple variants and the value contains a digit
  // (suppresses meaningless badges like "Default Title" or color names like "Schwarz").
  function injectVariantBadge() {
    const cfg = window.MS_PDP;
    if (!cfg || !cfg.hasMultipleVariants || !cfg.variantsById) return;
    const host = document.querySelector(".product-template__media-wrapper .media-gallery__media-wrapper");
    if (!host || host.dataset.msVariantBadge) return;

    host.style.position = "relative";
    let badge = host.querySelector(".ms-variant-badge");
    if (!badge) {
      badge = document.createElement("div");
      badge.className = "ms-variant-badge";
      host.appendChild(badge);
    }

    function update(variantId) {
      const v = cfg.variantsById[variantId];
      const value = v && v.option1;
      if (value && /\d/.test(value)) {
        badge.textContent = value;
        badge.style.display = "";
      } else {
        badge.style.display = "none";
      }
    }

    // Variant picker writes the active variant id into the cart form's hidden input.
    // Watch both attribute mutations and `change` events to cover both update styles.
    const form = document.querySelector('form[action*="/cart/add"]');
    const idInput = form && form.querySelector('input[name="id"]');
    update(idInput?.value || cfg.initialVariantId);
    if (!idInput) return;
    variantBadgeObserver = new MutationObserver(function () {
      update(idInput.value);
    });
    variantBadgeObserver.observe(idInput, { attributes: true, attributeFilter: ["value"] });
    variantBadgeHost = host;
    host.dataset.msVariantBadge = '1';
    variantBadgeController = new AbortController();
    idInput.addEventListener("change", function () {
      update(idInput.value);
    }, { signal: variantBadgeController.signal });
  }

  function normalizeForCompare(s) {
    return (s || "")
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "")
      .trim();
  }

  function injectImageCaption() {
    const media = document.querySelector(".product-template__media-wrapper .media-gallery__media-wrapper");
    if (!media || media.dataset.msCaptionInjected) return;

    const caption = document.createElement("div");
    caption.className = "ms-image-caption";
    media.parentNode.insertBefore(caption, media.nextSibling);

    const titleEl = document.querySelector(".product-title, .product-template__content-wrapper h1");
    const normalizedTitle = normalizeForCompare(titleEl ? titleEl.textContent : "");

    function update() {
      const img = media.querySelector(".media-gallery__media-item.is-active img, .slide-item.is-active img");
      if (!img) {
        caption.textContent = "";
        return;
      }
      const alt = (img.getAttribute("alt") || "").trim();
      // Suppress when alt is missing, too short, or just the product title.
      if (alt && alt.length > CAPTION_MIN_ALT_LENGTH && normalizeForCompare(alt) !== normalizedTitle) {
        caption.textContent = alt;
      } else {
        caption.textContent = "";
      }
    }

    new MutationObserver(update).observe(media, {
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
    setTimeout(update, CAPTION_INITIAL_DELAY_MS);
    media.dataset.msCaptionInjected = "1";
  }

  function loadTrustContentFromDom() {
    const nodes = document.querySelectorAll(".ms-trust-modals-data [data-ms-modal-index]");
    if (!nodes.length) return null;
    const content = {};
    nodes.forEach(function (node) {
      const idx = parseInt(node.getAttribute("data-ms-modal-index"), 10);
      const key = TRUST_KEY_BY_INDEX[idx];
      if (!key) return;
      content[key] = {
        title: node.getAttribute("data-ms-modal-title") || "",
        body: node.innerHTML.trim(),
      };
    });
    return content;
  }

  let trustContentCache = null;
  function getTrustContent() {
    if (trustContentCache) return trustContentCache;
    trustContentCache = loadTrustContentFromDom() || TRUST_CONTENT_FALLBACK;
    return trustContentCache;
  }

  let modalLastFocus = null;
  let modalPriorBodyOverflow = "";

  function ensureTrustModal() {
    if (document.getElementById("ms-trust-modal")) return;
    const m = document.createElement("div");
    m.id = "ms-trust-modal";
    m.className = "ms-modal";
    m.setAttribute("aria-hidden", "true");
    m.innerHTML =
      '<div class="ms-modal__overlay" data-ms-close></div>' +
      '<div class="ms-modal__panel" role="dialog" aria-modal="true" aria-labelledby="ms-trust-modal-title">' +
      '<button type="button" class="ms-modal__close" aria-label="Schliessen" data-ms-close>&times;</button>' +
      '<h3 class="ms-modal__title" id="ms-trust-modal-title"></h3>' +
      '<div class="ms-modal__body"></div>' +
      "</div>";
    document.body.appendChild(m);

    m.addEventListener("click", function (e) {
      if (e.target.hasAttribute("data-ms-close")) closeTrustModal();
    });
    document.addEventListener("keydown", function (e) {
      if (!m.classList.contains("is-open")) return;
      if (e.key === "Escape") closeTrustModal();
      if (e.key === "Tab") trapTab(e, m);
    });
  }

  function trapTab(e, m) {
    const focusable = m.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function openTrustModal(key) {
    openModal(getTrustContent()[key]);
  }

  function openModal(content, variant) {
    if (!content) return;
    ensureTrustModal();
    const m = document.getElementById("ms-trust-modal");
    modalLastFocus = document.activeElement;
    m.classList.toggle("ms-modal--wide", variant === "wide");
    m.querySelector(".ms-modal__title").textContent = content.title;
    m.querySelector(".ms-modal__body").innerHTML = content.body;
    m.classList.add("is-open");
    m.setAttribute("aria-hidden", "false");
    modalPriorBodyOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    setTimeout(function () {
      const btn = m.querySelector(".ms-modal__close");
      if (btn) btn.focus();
    }, MODAL_FOCUS_DELAY_MS);
  }

  function closeTrustModal() {
    const m = document.getElementById("ms-trust-modal");
    if (!m) return;
    m.classList.remove("is-open");
    m.setAttribute("aria-hidden", "true");
    document.body.style.overflow = modalPriorBodyOverflow;
    if (modalLastFocus && typeof modalLastFocus.focus === "function") {
      modalLastFocus.focus();
    }
    modalLastFocus = null;
  }

  // SH-121: "hier" in the "Gesetzliche Gewährleistungsrechte" accordion item
  // opens the legal guarantee label (rendered hidden by pdp-trust-modals).
  const LEGAL_LABEL_LINK_SEL = 'a[href="#gewaehrleistungsrechte"], a[data-ms-legal-label-link]';

  function getLegalLabelContent() {
    const node = document.querySelector(".ms-trust-modals-data [data-ms-legal-label]");
    if (!node) return null;
    return {
      title: node.getAttribute("data-ms-modal-title") || "",
      body: node.innerHTML.trim(),
      src: node.getAttribute("data-ms-legal-label-src") || "",
    };
  }

  // Point the link at the label image itself so middle-click / "open in new
  // tab" still work; a normal click is intercepted and opens the overlay.
  function wireLegalLabelLinks() {
    const content = getLegalLabelContent();
    if (!content) return;
    document.querySelectorAll(LEGAL_LABEL_LINK_SEL).forEach(function (link) {
      if (link.dataset.msLegalLabelLink) return;
      link.dataset.msLegalLabelLink = "1";
      link.setAttribute("aria-haspopup", "dialog");
      if (content.src) link.setAttribute("href", content.src);
    });
  }

  document.addEventListener("click", function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const link = e.target.closest && e.target.closest(LEGAL_LABEL_LINK_SEL);
    if (!link) return;
    const content = getLegalLabelContent();
    if (!content) return;
    e.preventDefault();
    openModal(content, "wide");
  });

  function wireTrustStrip() {
    const section = document.querySelector('[id$="__trust_strip"]');
    if (!section || section.dataset.msTrustWired) return;
    section.querySelectorAll(".text-icon-column__item").forEach(function (item, i) {
      const key = TRUST_KEY_BY_INDEX[i];
      if (!key) return;
      item.setAttribute("role", "button");
      item.setAttribute("tabindex", "0");
      item.addEventListener("click", function () {
        openTrustModal(key);
      });
      item.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          openTrustModal(key);
        }
      });
    });
    section.dataset.msTrustWired = "1";
  }

  // ── Metafield-driven accordion content ──
  // Per-product data is exposed via window.MS_PDP.metafields. We replace the
  // .faq-content of each tab whose data is populated; tabs without data keep
  // their section-defined placeholder.

  function getMf(key) {
    const v = window.MS_PDP && window.MS_PDP.metafields ? window.MS_PDP.metafields[key] : null;
    // List metafields can arrive as a JSON-encoded string when the Shopify
    // definition isn't list.single_line_text_field. Parse so renderers can iterate.
    if (typeof v === "string") {
      const s = v.trim();
      if (s.length > 1 && s[0] === "[" && s[s.length - 1] === "]") {
        try {
          return JSON.parse(s);
        } catch (e) {
          /* leave as string */
        }
      }
    }
    return v;
  }

  function findTabByHeadingPattern(rx) {
    const section = document.querySelector('[id$="__accordion"]');
    if (!section) return null;
    const items = section.querySelectorAll(".faq-item");
    for (let i = 0; i < items.length; i++) {
      const h = items[i].querySelector(".faq-collapsible");
      if (h && rx.test((h.textContent || "").trim())) return items[i];
    }
    return null;
  }

  function escHtml(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#39;");
  }

  // Like escHtml, but keep <br>, <br/>, and <br /> intact — CT spec values
  // arrive with literal HTML line breaks that should render as breaks.
  function escHtmlAllowBr(s) {
    return escHtml(s).replace(/&lt;br\s*\/?&gt;/gi, "<br>");
  }

  // Manufacturer (GPSR "Hersteller"). Dual-mode: custom.manufacturer arrives as
  // the new `manufacturer` metaobject reference (object: name/address/email/
  // website) OR, during the transition, as a legacy plain-text string. Renders
  // structured lines for the object; falls back to text for the string.
  function renderManufacturer(m) {
    if (!m) return "";
    if (typeof m === "string") return escHtmlAllowBr(m);
    var out = [];
    if (m.name) out.push('<div class="ms-mfr__name">' + escHtml(m.name) + "</div>");
    if (m.address) out.push('<div class="ms-mfr__address">' + escHtmlAllowBr(m.address) + "</div>");
    if (m.website) {
      var url = String(m.website).trim();
      if (!/^https?:\/\//i.test(url)) url = "https://" + url;
      out.push('<div class="ms-mfr__website"><a href="' + escHtml(url) + '" target="_blank" rel="noopener nofollow">' + escHtml(m.website) + "</a></div>");
    }
    if (m.email) out.push('<div class="ms-mfr__email"><a href="mailto:' + escHtml(m.email) + '">' + escHtml(m.email) + "</a></div>");
    return out.join("");
  }

  // Sanitize a first-party HTML string (PIM rich-text fields like
  // safety_instructions / usps arrive as real HTML, e.g. <ul><li>…</li></ul>).
  // We inject it via innerHTML, so allowlist a safe tag subset and strip every
  // attribute except href on <a> (and drop javascript:/data: hrefs). Disallowed
  // elements are unwrapped (their text is kept); comments are removed.
  function sanitizeHtml(input) {
    const ALLOWED = { UL: 1, OL: 1, LI: 1, P: 1, BR: 1, STRONG: 1, B: 1, EM: 1, I: 1, A: 1, SPAN: 1 };
    const tpl = document.createElement("template");
    tpl.innerHTML = String(input == null ? "" : input);
    function clean(parent) {
      let child = parent.firstChild;
      while (child) {
        let next = child.nextSibling;
        if (child.nodeType === 1) {
          if (ALLOWED[child.tagName]) {
            const attrs = Array.prototype.slice.call(child.attributes);
            for (let i = 0; i < attrs.length; i++) {
              const a = attrs[i];
              const keepHref =
                child.tagName === "A" && a.name === "href" && !/^\s*(javascript|data):/i.test(a.value);
              if (!keepHref) child.removeAttribute(a.name);
            }
            clean(child);
          } else {
            // Disallowed element: unwrap it, keeping its (still-to-be-cleaned) children.
            const first = child.firstChild;
            while (child.firstChild) parent.insertBefore(child.firstChild, child);
            parent.removeChild(child);
            next = first || next; // reprocess the promoted children
          }
        } else if (child.nodeType === 8) {
          parent.removeChild(child); // comment
        }
        child = next;
      }
    }
    clean(tpl.content);
    return tpl.innerHTML;
  }

  // Render a PIM field that may be EITHER real HTML (e.g. <ul><li>…</li></ul>)
  // OR plain text with line breaks (e.g. "Heading:\nWasser, …"). HTML is
  // sanitized as-is; plain text is escaped with newlines turned into <br>.
  function renderRichOrText(value) {
    const s = String(value == null ? "" : value);
    if (/<\/?[a-z][\s\S]*>/i.test(s)) return sanitizeHtml(s); // contains a tag → HTML
    return escHtml(s).replace(/\r?\n/g, "<br>");
  }

  // The PIM editor leaves empty blocks in some values — <p></p>, <p><br></p>,
  // bare <ul></ul>, and <div><br></div> spacers whose <div> sanitizeHtml unwraps
  // into a stray <br>. All of them print as blank lines. Drop them, then trim
  // whatever breaks are left at the edges.
  function tidyRichText(html) {
    let s = String(html == null ? "" : html);
    let prev;
    do {
      prev = s;
      s = s
        .replace(/<p>(?:\s|&nbsp;|<br\s*\/?>)*<\/p>/gi, "")
        .replace(/<(ul|ol)>\s*<\/\1>/gi, "");
    } while (s !== prev); // nested empties collapse over successive passes
    return s.replace(/^(?:\s|&nbsp;|<br\s*\/?>)+/i, "").replace(/(?:\s|&nbsp;|<br\s*\/?>)+$/i, "");
  }

  function hasSpecValue(value) {
    if (Array.isArray(value)) return value.some(hasSpecValue);
    return value !== null && value !== undefined && (typeof value !== "string" || value.trim() !== "");
  }

  function formatSpecValue(value) {
    if (Array.isArray(value)) return value.filter(hasSpecValue).map(formatSpecValue).join("<br>");
    return escHtmlAllowBr(value).replace(/\r?\n/g, "<br>");
  }

  // Coerce JSON-encoded array strings ("[\"a\",\"b\"]") to real arrays.
  // Tolerates the case where Shopify stored a list value as a single string
  // (e.g. when the definition isn't list.single_line_text_field), and the
  // case where the importer wrapped the JSON string into a 1-element list.
  function parseJsonArrayString(s) {
    if (typeof s !== "string") return null;
    const t = s.trim();
    if (t.length < 2 || t[0] !== "[" || t[t.length - 1] !== "]") return null;
    try {
      const parsed = JSON.parse(t);
      return Array.isArray(parsed) ? parsed : null;
    } catch (e) {
      return null;
    }
  }
  function asArray(v) {
    if (Array.isArray(v)) {
      // Unwrap single-element lists where the only item is itself a JSON array.
      if (v.length === 1 && typeof v[0] === "string") {
        const inner = parseJsonArrayString(v[0]);
        if (inner) return inner;
      }
      return v;
    }
    return parseJsonArrayString(v);
  }

  function youtubeEmbedUrl(url) {
    if (!url || typeof url !== "string") return null;
    const m = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
    return m ? "https://www.youtube.com/embed/" + m[1] : null;
  }

  function getAccordionVideoUrls() {
    return [
      youtubeEmbedUrl(getMf("youtube_video_link")),
      youtubeEmbedUrl(getMf("user_video_guide")),
    ].filter(Boolean);
  }

  function getAccordionDownloads() {
    const downloads = window.MS_PDP && window.MS_PDP.downloads;
    if (!Array.isArray(downloads)) return [];
    return downloads.flatMap(function (file) {
      if (!file || typeof file.url !== "string" || typeof file.label !== "string") return [];
      try {
        const raw = file.url.trim();
        const url = new URL(raw.startsWith("//") ? "https:" + raw : raw);
        if (url.protocol !== "https:" && url.protocol !== "http:") return [];
        return [{ label: file.label, url: url.href }];
      } catch (e) {
        return [];
      }
    });
  }

  function wireVideoShortcut() {
    const shortcut = document.querySelector("[data-ms-video-shortcut]");
    if (!shortcut) return;

    const videoTab = findTabByHeadingPattern(/^videos?/i);
    shortcut.hidden =
      getAccordionVideoUrls().length === 0 || !videoTab || videoTab.style.display === "none";
    if (shortcut.hidden || shortcut.dataset.msWired) return;

    shortcut.dataset.msWired = "1";
    shortcut.addEventListener("click", function () {
      videoTab.scrollIntoView({ behavior: "smooth", block: "start" });
      openFaqItem(videoTab);
      setTimeout(function () {
        videoTab.scrollIntoView({ behavior: "smooth", block: "start" });
      }, ANCHOR_FAQ_RECHECK_DELAY_MS + 400);
    });
  }

  // Hide an accordion tab outright when the product has no data for it.
  // Mirrors live mediashop's full pattern (AccordionPDP.tsx): ratings shown
  // only when ratingCount > 0, downloads only when assets exist, videos only
  // when hasVideos, productSafety only when any safety data exists. Without
  // this the PDP shows empty tabs that open to placeholder text.
  function hideEmptyAccordionTabs() {
    const data = window.MS_PDP || {};
    const mf = data.metafields || {};
    const reviewsCount = data.reviewsCount || 0;
    const hasDownloads = getAccordionDownloads().length > 0;
    const hasVideos = getAccordionVideoUrls().length > 0;
    const hasHazards = Array.isArray(data.hazard_warnings) && data.hazard_warnings.length > 0;
    const hasSafetyPictograms = Array.isArray(data.safety_pictograms) && data.safety_pictograms.length > 0;
    const hasGpsr = !!(mf.manufacturer || mf.safety_instructions) || hasHazards || hasSafetyPictograms;
    const hasIngredients = !!(mf.cosmetics_ingredients || mf.food_ingredients);

    function hideTab(rx) {
      const tab = findTabByHeadingPattern(rx);
      if (tab) tab.style.display = "none";
    }

    if (reviewsCount === 0) hideTab(/bewertungen|reviews/i);
    if (!hasDownloads) hideTab(/downloads|herunterlad/i);
    if (!hasVideos) hideTab(/^videos?/i);
    if (!hasGpsr) hideTab(/gpsr|produktsicherheit/i);
    if (!hasIngredients) hideTab(/inhaltsstoffe|zutaten/i);
  }

  function injectAccordionContent() {
    hideEmptyAccordionTabs();
    // Downloads — number only usable files, preserving category and admin order.
    const downloads = getAccordionDownloads();
    if (downloads.length) {
      const tab = findTabByHeadingPattern(/downloads|herunterlad/i);
      const target = tab && tab.querySelector(".faq-content");
      if (target && !target.dataset.msInjected) {
        const totals = new Map();
        const positions = new Map();
        downloads.forEach(function (file) {
          totals.set(file.label, (totals.get(file.label) || 0) + 1);
        });
        target.innerHTML =
          '<div class="rte"><ul>' +
          downloads
            .map(function (file) {
              const position = (positions.get(file.label) || 0) + 1;
              positions.set(file.label, position);
              const label = file.label + (totals.get(file.label) > 1 ? " " + position : "");
              return (
                '<li><a href="' +
                escHtml(file.url) +
                '" target="_blank" rel="noopener noreferrer">' +
                escHtml(label) +
                "</a></li>"
              );
            })
            .join("") +
          "</ul></div>";
        target.dataset.msInjected = "1";
      }
    }

    // Produktbeschreibung — replace section placeholder with real product description.
    const description = window.MS_PDP && window.MS_PDP.description;
    if (description && description.trim()) {
      const tab = findTabByHeadingPattern(/produktbeschreibung|beschreibung/i);
      const target = tab && tab.querySelector(".faq-content");
      if (target && !target.dataset.msInjected) {
        target.innerHTML = '<div class="ms-description">' + description + "</div>";
        target.dataset.msInjected = "1";
      }
    }

    // Lieferumfang — single-row spec table: left label "Lieferumfang", right list of items.
    // Matches live's AccordionItem layout (label cell + value cell, alternating-row style).
    // PIM now writes this as a single rich-text blob (<ul><li>…</li></ul>) as well
    // as the original one-bullet-per-entry list, so route every entry through
    // renderRichOrText rather than escaping it. Tolerate a bare (non-list) value:
    // if the definition is ever migrated to multi_line_text_field the way `usps`
    // was, .value becomes a string and asArray would otherwise return null.
    const deliverablesRaw = getMf("deliverables");
    const deliverables =
      asArray(deliverablesRaw) ||
      (typeof deliverablesRaw === "string" && deliverablesRaw.trim() ? [deliverablesRaw] : null);
    if (deliverables && deliverables.length) {
      const tab = findTabByHeadingPattern(/lieferumfang/i);
      const target = tab && tab.querySelector(".faq-content");
      if (target && !target.dataset.msInjected) {
        const parts = deliverables
          .map(renderRichOrText)
          .filter(function (s) {
            return s.trim();
          });
        // Rich text brings its own block structure; plain entries are one bullet
        // each and still need explicit breaks between them.
        const rowsHtml = tidyRichText(
          parts.join(/<(ul|ol|p)\b/i.test(parts.join("")) ? "" : "<br>"),
        );
        target.innerHTML =
          '<table class="ms-specs"><tbody>' +
          '<tr><th>Lieferumfang</th><td><div class="ms-specs__rte rte">' +
          rowsHtml +
          "</div></td></tr>" +
          "</tbody></table>";
        target.dataset.msInjected = "1";
      }
    }

    // Produktdaten — key-value table. Labels mirror live mediashop PIM wording.
    // Order matters: general first, then physical/sensor/lighting, then battery/electronics,
    // then booleans (functional + compliance), then expiry.
    const specRows = [
      ["article_dimensions", "Artikelabmessungen (L x B x H in cm)"],
      ["product_weight_web", "Produktgewicht"],
      ["article_details", "Wichtige Artikeldetails"],
      ["product_material_composition", "Materialzusammensetzung"],
      ["brand", "Hersteller"],
      ["battery_type", "Batterieart"],
      ["product_care_note_cleaning", "Pflege / Reinigung"],
      ["product_maximum_load_weight", "Maximales Belastungsgewicht"],
      ["product_capacity_filling_quantity", "Fassungsvermögen / Füllmenge"],
      ["textil_material_composition", "Bezeichnung & Materialzusammensetzung Textil"],
      ["product_chemical_ingredients", "Chemische Inhaltsstoffe"],
      ["cable_type", "Kabelart"],
      ["usb_type", "USB Typ"],
      ["electronics_power_adapter_plug_type", "Steckertyp"],
      ["plug_voltage", "Gerät Spannung (in Volt)"],
      ["device_power", "Gerät Leistung (in Watt)"],
      ["electronics_power_adapter_input", "Netzteil Spannung Input (in Volt)"],
      ["electronics_power_adapter_ampere", "Netzteil Stromstärke Output"],
      ["electronics_power_adapter_rated_watt", "Netzteil Leistung Output"],
      ["product_noise_level_volume", "Geräuschpegel @ 30 cm (in Dezibel)"],
      ["product_speed", "Geschwindigkeit"],
      ["storage_type", "Akkutyp"],
      ["product_battery_charging_time", "Akku Ladezeit"],
      ["product_battery_run_time", "Akku Laufzeit"],
      ["battery_capacity", "Akkukapazität (gesamt)"],
      ["remote_control", "Art der Fernbedienung"],
      ["remote_control_battery_sort", "Fernbedienung — Batterietyp"],
      ["remote_control_battery_type", "Fernbedienung — Batteriegröße"],
      ["ip_classification", "IP-Klasse"],
      ["number_of_leds", "Anzahl LEDs"],
      ["led_watt", "LED-Watt"],
      ["product_cable_length", "Kabellänge"],
      ["sensor_distance", "Sensorreichweite"],
      ["sensor_detection_angle", "Sensor Erfassungswinkel"],
      ["electronics_num_of_batteries", "Anzahl Batterien"],
      ["electronics_power_adapter_rated_voltage", "Netzteil Spannung (Output)"],
      ["remote_control_battery_num_of_batteries", "Fernbedienung — Anzahl Batterien"],
    ]
      .map(function (pair) {
        const val = getMf(pair[0]);
        // Numbers can legitimately be 0; only filter null/undefined/empty-string.
        return hasSpecValue(val) ? [pair[1], val] : null;
      })
      .filter(Boolean);

    const hasMainBatteryDetails =
      hasSpecValue(getMf("battery_type")) || hasSpecValue(getMf("electronics_num_of_batteries"));

    const batteriesIncluded = getMf("electronics_batteries_included");
    if (hasMainBatteryDetails && (batteriesIncluded === true || batteriesIncluded === false)) {
      specRows.push(["Batterien inklusive", batteriesIncluded ? "Ja" : "Nein"]);
    }

    const hasRemoteBatteryDetails =
      hasSpecValue(getMf("remote_control_battery_num_of_batteries")) ||
      hasSpecValue(getMf("remote_control_battery_sort")) ||
      hasSpecValue(getMf("remote_control_battery_type"));

    const remoteBatteriesIncluded = getMf("remote_control_battery_included");
    if (hasRemoteBatteryDetails && (remoteBatteriesIncluded === true || remoteBatteriesIncluded === false)) {
      specRows.push(["Fernbedienung — Batterien inklusive", remoteBatteriesIncluded ? "Ja" : "Nein"]);
    }

    // Functional booleans — always show Ja/Nein when value is present.
    [
      ["battery_included", "Akku inklusive"],
      ["battery_solar", "Solar-Akku"],
      ["electronics_power_adapter_included", "Netzteil inklusive"],
      ["remote_control_exists", "Fernbedienung"],
    ].forEach(function (pair) {
      const v = getMf(pair[0]);
      if (v === true || v === false) specRows.push([pair[1], v ? "Ja" : "Nein"]);
    });

    // Compliance flags — only show when true (a "Nein" here is not useful).
    [
      ["medical_product", "Medizinprodukt"],
      ["biocidal_product", "Biozidprodukt"],
      ["dishwasher_fitting", "Spülmaschinengeeignet"],
    ].forEach(function (pair) {
      if (getMf(pair[0]) === true) specRows.push([pair[1], "Ja"]);
    });

    // Expiry date — format ISO YYYY-MM-DD as German DD.MM.YYYY.
    const expiryRaw = getMf("expiry_date");
    if (expiryRaw && typeof expiryRaw === "string") {
      const m = expiryRaw.match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) specRows.push(["Mindesthaltbarkeit", m[3] + "." + m[2] + "." + m[1]]);
    }

    if (specRows.length) {
      const tab = findTabByHeadingPattern(/produktdaten/i);
      const target = tab && tab.querySelector(".faq-content");
      if (target && !target.dataset.msInjected) {
        target.innerHTML =
          '<table class="ms-specs"><tbody>' +
          specRows
            .map(function (r) {
              return '<tr><th scope="row">' + escHtml(r[0]) + "</th><td>" + formatSpecValue(r[1]) + "</td></tr>";
            })
            .join("") +
          "</tbody></table>";
        target.dataset.msInjected = "1";
      }
    }

    // Videos — embed YouTube URLs
    const videos = getAccordionVideoUrls();
    if (videos.length) {
      const tab = findTabByHeadingPattern(/^videos?/i);
      const target = tab && tab.querySelector(".faq-content");
      if (target && !target.dataset.msInjected) {
        target.innerHTML =
          '<div class="ms-videos">' +
          videos
            .map(function (src) {
              return (
                '<div class="ms-video-embed"><iframe src="' +
                src +
                '" loading="lazy" allowfullscreen frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"></iframe></div>'
              );
            })
            .join("") +
          "</div>";
        target.dataset.msInjected = "1";
      }
    }

    // GPSR — manufacturer + safety instructions + safety pictograms + hazard warnings.
    const manufacturer = getMf("manufacturer");
    const safety = getMf("safety_instructions");
    const safetyPictograms = (window.MS_PDP && Array.isArray(window.MS_PDP.safety_pictograms))
      ? window.MS_PDP.safety_pictograms.filter(function (pictogram) {
          return pictogram && pictogram.image;
        })
      : [];
    const hazards = (window.MS_PDP && Array.isArray(window.MS_PDP.hazard_warnings))
      ? window.MS_PDP.hazard_warnings
      : [];
    if (manufacturer || safety || safetyPictograms.length || hazards.length) {
      const tab = findTabByHeadingPattern(/gpsr|produktsicherheit/i);
      const target = tab && tab.querySelector(".faq-content");
      if (target && !target.dataset.msInjected) {
        let html = '<div class="ms-gpsr">';
        if (manufacturer) {
          html += '<div class="ms-gpsr__block"><strong>Hersteller</strong>' + renderManufacturer(manufacturer) + "</div>";
        }
        if (safety) {
          // safety_instructions is a PIM rich-text field — real HTML (e.g.
          // <ul><li>…</li></ul>). Render it sanitized, NOT escaped (escaping
          // was the bug that printed the raw tags on the page).
          html +=
            '<div class="ms-gpsr__block"><strong>Sicherheitshinweise</strong>' +
            '<div class="ms-gpsr__rte rte">' + renderRichOrText(safety) + "</div>" +
            "</div>";
        }
        if (safetyPictograms.length || hazards.length) {
          // Hazard warnings come from the `hazard_warning` metaobject (one entry
          // per P-code, e.g. P391). `statement` is a plain `multi_line_text_field`
          // — strip any wrapping `<p>...</p>` (Ainavio used to inject it; expected
          // to be removed in their next sync) and escape the rest defensively.
          html += '<div class="ms-gpsr__block ms-gpsr__block--hazards"><strong>Gefahrenhinweise</strong>';
          if (safetyPictograms.length) {
            html += '<div class="ms-safety-pictograms" role="list">';
            safetyPictograms.forEach(function (pictogram) {
              const label = pictogram.label || pictogram.code || "Sicherheitspiktogramm";
              html +=
                '<figure class="ms-safety-pictogram" role="listitem">' +
                '<img class="ms-safety-pictogram__image" src="' + escHtml(pictogram.image) + '" alt="" loading="lazy" width="247" height="83">' +
                '<figcaption class="ms-safety-pictogram__label">' + escHtml(label) + '</figcaption>' +
                '</figure>';
            });
            html += '</div>';
          }
          if (hazards.length) {
            html += '<ul class="ms-hazards">';
            hazards.forEach(function (h) {
              html += '<li class="ms-hazards__item">';
              if (h.pictogram) {
                html += '<img class="ms-hazards__pictogram" src="' + escHtml(h.pictogram) + '" alt="" loading="lazy" width="247" height="83">';
              }
              html += '<div class="ms-hazards__content">';
              if (h.code) html += '<span class="ms-hazards__code">' + escHtml(h.code) + '</span>';
              if (h.signal_word) html += ' <span class="ms-hazards__signal">' + escHtml(h.signal_word) + '</span>';
              if (h.statement) {
                const cleaned = String(h.statement).replace(/^<p>([\s\S]*)<\/p>\s*$/i, "$1").trim();
                html += ' <span class="ms-hazards__statement">' + escHtml(cleaned) + '</span>';
              }
              html += '</div></li>';
            });
            html += "</ul>";
          }
          html += "</div>";
        }
        html += "</div>";
        target.innerHTML = html;
        target.dataset.msInjected = "1";
      }
    }

    // Inhaltsstoffe — cosmetics_ingredients / food_ingredients are PIM rich-text
    // (HTML, e.g. <ul><li>…</li></ul> or <p>…</p>). Render sanitized, NOT escaped.
    // A product is normally cosmetic OR food, but both are handled if present.
    const cosmetics = getMf("cosmetics_ingredients");
    const food = getMf("food_ingredients");
    if (cosmetics || food) {
      const tab = findTabByHeadingPattern(/inhaltsstoffe|zutaten/i);
      const target = tab && tab.querySelector(".faq-content");
      if (target && !target.dataset.msInjected) {
        let html = '<div class="ms-ingredients">';
        if (cosmetics) {
          html += '<div class="ms-ingredients__rte rte">' + renderRichOrText(cosmetics) + "</div>";
        }
        if (food) {
          html += '<div class="ms-ingredients__rte rte">' + renderRichOrText(food) + "</div>";
        }
        html += "</div>";
        target.innerHTML = html;
        target.dataset.msInjected = "1";
      }
    }
  }

  // Subtitle is server-rendered by the `subtitle` HTML block in
  // templates/product.json (reads product.metafields.custom.subtitle). No JS
  // injection here — duplicating it created two identical lines on PDPs where
  // CT's `web_subtitle` and `claim` are the same string. If you ever need to
  // surface the `claim` metafield elsewhere (e.g. editorial hero), render it
  // server-side in that section, not via this script.
  function injectBuyBoxExtras() {}

  function runOnReady() {
    relabelSku();
    injectProductBadges();
    injectUvpBadge();
    injectVariantBadge();
    wireTrustStrip();
    // Image caption intentionally not injected: Ainavio fills image alt with the
    // raw filename (e.g. "09_Klickidoo_Filterrahmen.jpg"), and we have no curated
    // per-image caption data (the old site used a dedicated image.usp field, not
    // alt). Showing filename junk under the gallery is worse than nothing.
    // Order matters: injectAccordionContent() hides empty tabs (Bewertungen,
    // Downloads) before populateAnchorNav() reads the visible tab list,
    // otherwise the top anchor nav links to tabs that no longer exist.
    injectAccordionContent();
    wireLegalLabelLinks();
    wireVideoShortcut();
    populateAnchorNav();
    wireMehrDetailsScroll();
    injectBuyBoxExtras();
  }

  function init() {
    if (!variantBadgeHost?.isConnected) {
      variantBadgeObserver?.disconnect();
      variantBadgeController?.abort();
      variantBadgeObserver = null;
      variantBadgeHost = null;
    }
    retryTimers.forEach(clearTimeout);
    trustContentCache = null;
    runOnReady();
    watchAccordion();
    retryTimers = INIT_RETRY_DELAYS_MS.map(function (delay) {
      return setTimeout(runOnReady, delay);
    });
  }

  document.addEventListener("alpine:initialized", function () {
    faqAttempt = 0;
    pulseFaq();
  });

  document.addEventListener('ms:product-swapped', function () {
    faqAttempt = 0;
    init();
  });

  if (document.readyState !== "loading") {
    init();
  } else {
    document.addEventListener("DOMContentLoaded", init);
  }
})();

/* "2. Stück" quantity selector — mirrors the product quantity input both ways.
   The deal row always shows 2 pieces; any quantity of 2 or more selects it. */
(function () {
  // Formats like Liquid's `money` filter for the active market by reading a sample
  // the snippet rendered (12345.67), so CHF never picks up the shop's € format.
  function moneyFormatter(sample) {
    var m = /^(.*?)12(\D?)345(\D)67(.*)$/.exec((sample || "").replace(/<[^>]*>/g, "").trim());
    if (!m) {
      var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || "EUR";
      return function (cents, trimZeros) {
        var opts = { style: "currency", currency: currency };
        if (trimZeros && cents % 100 === 0) opts.minimumFractionDigits = 0;
        return new Intl.NumberFormat(document.documentElement.lang || "de", opts).format(cents / 100);
      };
    }
    return function (cents, trimZeros) {
      var whole = String(Math.floor(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, m[2]);
      var frac = String(cents % 100).padStart(2, "0");
      return m[1] + whole + (trimZeros && frac === "00" ? "" : m[3] + frac) + m[4];
    };
  }

  function sectionRoot(block) {
    return block.closest(".shopify-section") || document;
  }

  // The buy-buttons box (id "Quantity-<block>"); the sticky bar's "QuantitySticky-" box submits its own form.
  function quantityInput(block) {
    return sectionRoot(block).querySelector('input[name="quantity"][id^="Quantity-"]');
  }

  function readQty(block) {
    var input = quantityInput(block);
    var n = input ? parseInt(input.value, 10) : 1;
    return Number.isInteger(n) && n >= 1 ? n : 1;
  }

  function render(block, qty) {
    var unit = parseInt(block.getAttribute("data-unit-cents"), 10);
    var saving = parseInt(block.getAttribute("data-saving-cents"), 10) || 0;
    if (!(unit > saving)) {
      block.hidden = true;
      sectionRoot(block).querySelectorAll("[data-ms-2p-btn-total]").forEach(function (el) {
        el.hidden = true;
      });
      return;
    }
    block.hidden = false;

    var money = moneyFormatter(block.getAttribute("data-money-sample"));
    var set = function (sel, text) {
      var el = block.querySelector(sel);
      if (el) el.textContent = text;
    };
    set("[data-ms-2p-unit]", money(unit));
    set("[data-ms-2p-total-saving]", money(saving, true));
    set("[data-ms-2p-was]", money(2 * unit));
    set("[data-ms-2p-now]", money(2 * unit - saving));

    // Exact only for 1 and 2: from 3 pieces on, the live native discounts and the
    // 2. Stück function charge different totals, so the button shows no amount.
    var total = qty === 1 ? unit : qty === 2 ? 2 * unit - saving : null;
    sectionRoot(block).querySelectorAll("[data-ms-2p-btn-total]").forEach(function (el) {
      el.hidden = total === null;
      el.textContent = total === null ? "" : "\u00b7 " + money(total);
    });

    var selected = qty >= 2 ? "2" : "1";
    block.querySelectorAll("[data-ms-2p-row]").forEach(function (row) {
      var on = row.getAttribute("data-ms-2p-row") === selected;
      row.classList.toggle("is-selected", on);
      var radio = row.querySelector("input");
      if (radio) radio.checked = on;
    });
  }

  function renderSection(block) {
    var qty = readQty(block);
    var id = block.getAttribute("data-section-id");
    document.querySelectorAll('[data-ms-2p][data-section-id="' + id + '"]').forEach(function (b) {
      render(b, qty);
    });
  }

  function setQty(block, qty) {
    var input = quantityInput(block);
    if (!input) return;
    input.value = qty;
    // x-model listens for "input"; the theme's own $watch then keeps every copy in sync.
    input.dispatchEvent(new Event("input", { bubbles: true }));
    renderSection(block);
  }

  var listeners;
  function bindBlocks() {
    if (listeners) listeners.abort();
    listeners = new AbortController();
    var signal = listeners.signal;
    var boundSections = {};

    document.querySelectorAll("[data-ms-2p]").forEach(function (block) {
      var sectionId = block.getAttribute("data-section-id");
      if (!sectionId) return;

      block.addEventListener("change", function (e) {
        if (!e.target.matches(".ms-2p__radio")) return;
        // Keep a larger quantity when the customer re-selects the deal row.
        var want = parseInt(e.target.value, 10);
        setQty(block, want === 2 ? Math.max(2, readQty(block)) : 1);
      }, { signal: signal });

      if (boundSections[sectionId]) return;
      boundSections[sectionId] = true;

      document.addEventListener("maximize:variant-picker:updated:" + sectionId, function (e) {
        var v = e.detail && e.detail.currentVariant;
        if (!v || !block.isConnected) return;
        document.querySelectorAll('[data-ms-2p][data-section-id="' + sectionId + '"]').forEach(function (b) {
          b.setAttribute("data-unit-cents", String(v.price));
        });
        // The theme resets quantity to 1 on variant change.
        renderSection(block);
      }, { signal: signal });

      var root = sectionRoot(block);
      var sync = function () { requestAnimationFrame(function () { renderSection(block); }); };
      root.addEventListener("input", function (e) {
        if (e.target.matches('input[x-ref="quantity_input"]')) sync();
      }, { signal: signal });
      root.addEventListener("focusout", function (e) {
        if (e.target.matches('input[x-ref="quantity_input"]')) sync();
      }, { signal: signal });
      // The +/- buttons change Alpine state, which writes input.value without firing an event.
      root.addEventListener("click", function (e) {
        if (e.target.closest('[name="plus"], [name="minus"]')) sync();
      }, { signal: signal });

      renderSection(block);
    });
  }

  bindBlocks();
  document.addEventListener("alpine:initialized", bindBlocks);
  document.addEventListener("ms:product-swapped", bindBlocks);
})();
